import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

const SecurityTab = () => {
  return (
    <div className="space-y-6">
      {/* Change Password */}
      <Card className="border-none shadow-sm">
        <CardHeader className="border-b border-gray-50 pb-3">
          <CardTitle className="text-lg font-bold">Change Password</CardTitle>
          <p className="text-xs font-medium tracking-tight text-gray-500">
            Update your password to keep your account secure
          </p>
        </CardHeader>
        <CardContent className="space-y-4 pt-6">
          <div className="space-y-1.5">
            <Label className="text-[10px] font-bold uppercase tracking-widest text-gray-400">
              Current Password
            </Label>
            <Input
              type="password"
              placeholder="••••••••"
              className="border-gray-100 bg-gray-50/50 text-sm font-bold"
            />
          </div>
          <div className="space-y-1.5">
            <Label className="text-[10px] font-bold uppercase tracking-widest text-gray-400">
              New Password
            </Label>
            <Input
              type="password"
              placeholder="••••••••"
              className="border-gray-100 bg-gray-50/50 text-sm font-bold"
            />
          </div>
          <div className="space-y-1.5">
            <Label className="text-[10px] font-bold uppercase tracking-widest text-gray-400">
              Confirm New Password
            </Label>
            <Input
              type="password"
              placeholder="••••••••"
              className="border-gray-100 bg-gray-50/50 text-sm font-bold"
            />
          </div>
          <Button className="h-9 rounded-md bg-black px-6 text-xs font-bold text-white shadow-sm hover:bg-gray-800">
            Update Password
          </Button>
        </CardContent>
      </Card>

      {/* Two Factor Authentication */}
      <Card className="border-none shadow-sm">
        <CardHeader className="border-b border-gray-50 pb-3">
          <CardTitle className="text-lg font-bold">
            Two Factor Authentication
          </CardTitle>
          <p className="text-xs font-medium tracking-tight text-gray-500">
            Add an extra layer of security to your account
          </p>
        </CardHeader>
        <CardContent className="pt-6">
          <div className="flex items-center justify-between">
            <div className="space-y-0.5">
              <Label className="cursor-pointer text-sm font-bold text-gray-800">
                Enable 2FA
              </Label>
              <p className="text-xs font-medium tracking-tight text-gray-400">
                Require authentication code in addition to password
              </p>
            </div>
            <Switch />
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default SecurityTab;
